import { FC } from 'react';
import { MdBlock } from 'react-icons/md';
import { useI18n } from 'contexts/i18n';
import * as Styled from './IDSStoreDisabledMessage.styles';

interface IDSStoreDisabledMessageProps {
  reason: string;
}

const IDSStoreDisabledMessage: FC<IDSStoreDisabledMessageProps> = ({
  reason,
}) => {
  const i18n = useI18n();
  return (
    <Styled.Container>
      <Styled.IconWrapper>
        <MdBlock size={48} />
      </Styled.IconWrapper>
      <Styled.Title>
        {i18n['Unauthorized Access.'] || 'Unauthorized access.'}
      </Styled.Title>
      <Styled.Message>
        {i18n['You are not authorized to access IDS Store'] ||
          'You are not authorized to access IDS Store'}
      </Styled.Message>
      <Styled.Message>{i18n[reason] || reason}</Styled.Message>
      <Styled.Message>
        {i18n['Other parts of the Invisalign doctor site are available as usual.'] ||
          'Other parts of the Invisalign doctor site are available as usual.'}
      </Styled.Message>
    </Styled.Container>
  );
};

export default IDSStoreDisabledMessage;
